import React from "react";
import { Form } from "antd";
import Select, { components } from "react-select";
const { Option } = Select;

const UiDropDown = (props) => {
  const {
    title,
    required,
    onSearch,
    value,
    multiple,
    disabled,
    tabIndex,
    validation,
    style,
    size,
    placeholder,
    data,
    onChange,
    className,
    defaultValue,
  } = props;

  const customStyles = {
    root: (base) => ({
      ...base,
      marginTop: "5px",
    }),
    control: (base) => ({
      ...base,
      height: 33,
      minHeight: 30,
      marginTop: className === "partner" ? "7px" : "0px",
      border: className === "partner" ? "1px solid rgb(159, 159, 159)" : "",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ccc",
      fontSize: 14,
    }),
  };

  return (
    <Select
      className={className}
      value={value}
      isMulti={multiple}
      isDisabled={disabled}
      tabIndex={tabIndex}
      defaultValue={defaultValue}
      placeholder={placeholder}
      style={style ?? {}}
      options={data}
      size={size ?? "small"}
      styles={customStyles}
      onSearch={onSearch}
      onChange={value => onChange(value)}
      {...props}
    />
  );
};

export default UiDropDown;
